import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { CircularProgress, Snackbar } from "@material-ui/core";
import { Shimmer, Image } from "react-shimmer";
import { Alert } from "@material-ui/lab";
import moment from "moment";

import "./orders.css";
import { api_call_token } from "../../utils/Network";
import { MainContext } from "../../utils/context";
import { appendImageUrl, isMobiledevice } from "../../utils/helperFunctions";
import Grp from "../../assets/grps.png";
import SwitchOrder from "../../components/SwitchOrder/SwitchOrder";
import ReviewPopup from "../../components/ReviewPopup";

function Orders() {
  const { userData, setUserData, setCurrentPath } = useContext(MainContext);
  const [loading, setLoading] = useState(true);
  const [activeOrders, setActiveOrders] = useState([]);
  const [pastOrders, setPastOrders] = useState([]);
  const [displayOrders, setDisplayOrders] = useState([]);
  const [idToReview, setIdToReview] = useState(0);
  const [msg, setMsg] = useState("");

  useEffect(() => setCurrentPath(window.location.href.split("/")[4]), []);
  useEffect(() => getOrders(), [userData]);

  const getOrders = () => {
    if (userData.id)
      api_call_token
        .get("auth/order/view_order/")
        .then((re) => {
          setDisplayOrders(re.data.data?.Active_order);
          setActiveOrders(re.data.data?.Active_order);
          setPastOrders(re.data.data?.Past_order);
          setLoading(false);
        })
        .catch((e) => console.log(e));
    else setTimeout(() => setLoading(false), 1000);
  };

  const cancelOrderHandler = (orderId = 0) => {
    api_call_token
      .post("auth/order/cancel_order/", { order_id: orderId })
      .then((re) => getOrders())
      .catch((e) => console.log(e));
    setTimeout(() => setMsg("Order Cancelled Successfully"), 1000);
  };

  return (
    <>
      {idToReview > 0 && (
        <ReviewPopup
          show
          serviceId={idToReview}
          setMsg={setMsg}
          onClose={() => setIdToReview(0)}
        />
      )}
      <div className="orderHead cart-main">
        <h2 className="order-content">Orders</h2>
        <SwitchOrder
          onChange={(v) =>
            v ? setDisplayOrders(activeOrders) : setDisplayOrders(pastOrders)
          }
        />
        {/* <div>
          <div className="order_toggle">
            <button className="order_tgl">Upcoming</button>
            <button className="order_tgl">Past Orders</button>
          </div>
        </div> */}
      </div>
      <div className="order_content">
        {loading ? (
          <div style={{ margin: 100, textAlign: "center" }}>
            <CircularProgress size={75} />
          </div>
        ) : (
          displayOrders.length < 1 && (
            <div className="no_data_main">
              <div className="no_data_container">
                <img src={Grp} alt="circle" className="no_data_img" />
                <div>
                  <h1 className="no_data_title">Oops !</h1>
                  <p className="no_data_content">
                    Looks like you have no orders for this type
                  </p>
                </div>
              </div>
              <Link to="/">
                <button className="no_browse">Browse Services</button>
              </Link>
            </div>
          )
        )}
        {displayOrders.map((order) => (
          <div key={order.order_id} className="order_datas">
            <div className="cart-main order_container">
              <div className="Order_content_wrapper">
                <div style={{ width: "100%" }}>
                  <div className="order_id">
                    Order No: {order.order_id + "/" + order.invoice_no}
                    <br />
                    <span style={{ fontSize: 14, color: "#555" }}>
                      Date: {order.order_date}
                    </span>
                  </div>
                  {order.services.map((service) => (
                    <>
                      <div
                        key={service.service_id}
                        className="order_inner_cont"
                      >
                        <Image
                          src={appendImageUrl(
                            service.service_image
                              ? service.service_image
                              : "/files/files/Group_472x_Wj1mM5u.png"
                          )}
                          NativeImgProps={{ className: "OrderImg" }}
                          errorFallback={() => (
                            <Image
                              src={appendImageUrl(
                                "/files/files/Group_472x_Wj1mM5u.png"
                              )}
                              NativeImgProps={{ className: "OrderImg" }}
                            />
                          )}
                          fallback={
                            <Shimmer
                              height={isMobiledevice() ? 75 : 65}
                              width={isMobiledevice() ? 75 : 65}
                              className="OrderImg"
                            />
                          }
                        />
                        <div>
                          <div style={{ display: "flex" }}>
                            <h3 className="ocw_head">{service.service_name}</h3>
                          </div>
                          {/* <p className="ocw_para">
                          Lorem ipsum dolar sit amet, consecteturer adipiscing
                          elit, sed diam
                        </p> */}
                          <div className="dateTime">
                            <div className="ch_date">
                              {moment(service.order_booking_date).format(
                                "DD MMMM YYYY"
                              )}
                            </div>
                            <div style={{ marginLeft: 5 }} className="ch_time">
                              {moment(
                                service?.booking_time_slot?.slot_from,
                                "HH:mm:ss"
                              ).format("hh:mm A")}
                            </div>
                          </div>
                          {service.sub_service?.length > 0 && (
                            <div className="cart-main adons_order">
                              <h4>Add Ons</h4>
                              {service.sub_service.map((addon) => (
                                <div
                                  key={addon.service_id}
                                  className="adon_container"
                                >
                                  <div className="adon_main_wrapper">
                                    <Image
                                      src={appendImageUrl(
                                        addon.service_image
                                          ? addon.service_image
                                          : "/files/files/Group_1112x_uioXQAd.png"
                                      )}
                                      NativeImgProps={{ className: "adonImg" }}
                                      errorFallback={() => (
                                        <Image
                                          src={appendImageUrl(
                                            "/files/files/Group_1112x_uioXQAd.png"
                                          )}
                                          NativeImgProps={{
                                            className: "adonImg",
                                          }}
                                        />
                                      )}
                                      fallback={
                                        <Shimmer
                                          height={isMobiledevice() ? 45 : 55}
                                          width={isMobiledevice() ? 45 : 55}
                                          className="adonImg"
                                        />
                                      }
                                    />
                                    <h3
                                      style={{
                                        fontSize: "16px",
                                        margin: 0,
                                        fontWeight: 400,
                                      }}
                                    >
                                      {addon.quantity > 1
                                        ? addon.service_name +
                                          ` (${addon.quantity})`
                                        : addon.service_name}
                                    </h3>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="room_select_container">
                          <div className="roomselect">
                            {service.variant_name
                              ? `${service.variant_name} - ${service.sub_variant_name}`
                              : service.sub_variant_name}
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
              {/* <div className="room_select_container">
                <div className="roomselect">
                  {order.services[0]?.variant_name}
                </div>
              </div> */}
              <div className="amount_info">
                <div className="amts_ord">&#8377; {order.total_cost}</div>
                {/* <div><button className="btn_order">View Order</button></div> */}
                {/* <div>
                  <button
                    onClick={() => setIdToReview(order.services[0]?.service_id)}
                    className="btn_order btn_fade"
                  >
                    Review
                  </button>
                </div> */}
                {/* <div><button className="btn_order btn_fade_partial">Edit</button></div> */}
                <div>
                  <button
                    onClick={() =>
                      displayOrders === pastOrders
                        ? setIdToReview(order.services[0]?.service_id)
                        : cancelOrderHandler(order.order_id)
                    }
                    className="btn_order"
                  >
                    {displayOrders === pastOrders ? "Review" : "Cancel"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {msg && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setMsg("")}
          autoHideDuration={3000}
          message={msg}
        >
          <Alert
            severity={
              msg.includes("lease")
                ? "error"
                : msg.includes("ready")
                  ? "warning"
                  : "success"
            }
          >
            {msg}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default Orders;
